import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { DropDown, LinksWrap } from "../Layout/components/UserControls/UserControls.styled";

/* Style SortGroup */
export const SortDropDown = styled(DropDown)`
  position: static;
  padding: 0;
`;

/* Style SortGroup */
export const SortItem = styled.div`
  font-family: ${fonts.latoRegular};
  cursor: pointer;
  &.active {
    color: ${colors.RED};
  }
  &:hover {
    color: ${colors.RED};
    background-color: ${colors.GREY_LIGHT};
  }
`;

export const CurrentSort = styled.span`
  font-family: ${fonts.latoRegular};
  color: ${colors.RED};
`;
/* Style SortLabel */
export const SortLabel = styled.button` 
${SortItem} {
  margin-left: 4px;
};
.icon {
  margin-top: 2px;
  margin-left: 2px;
  stroke: ${colors.RED};
  fill: ${colors.RED};
};
  color: ${colors.GREY_DARK};
  padding: 0;
  padding-right: 16px; 
  display: flex;
  align-items: center;
  cursor: pointer;
  background: none;
  border: none;
  &.rotated {
    &::after {
    content: "";
    position: absolute;
    top: 10px;
    right: 2px;
    @media (min-width: 768px) {
      top: 10px;
    right: 2px;
    }
    width: 0;    
    height: 0;
    border-style: solid;
   
    ${(props) =>
      props.isRotated
        ? `      
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent ${colors.GREY_DARK} transparent;          
    `
        : `   
        border-width: 5px 5px 0 5px;
        border-color: ${colors.GREY_DARK} transparent transparent transparent;
    `}
  };
`;

/* Style SortSum */
export const SortSum = styled.div``;
/* Style SortWrap */
export const SortWrap = styled.div`
  position: relative;
`;

export const SortList = styled.div`
  display: flex;
`;

export const LinksWrapStyle = styled(LinksWrap)`
  left: auto;
  right: 0;
  margin-top: 0;
  > * {
    padding: 9px;
  }
  .active {
    color: ${colors.RED};
  }
  ${SortItem} + ${SortItem} {
    border-top: 1px solid ${colors.GREY_SEMILIGHT};
  }
`;

/* Style SortGroup */
export const SortGroup = styled.div`
  display: flex;
  margin-left: auto;  
  opacity: ${({ isDisabled }) => (isDisabled ? 0.4 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "all")};
  cursor: ${({ isDisabled }) => (isDisabled ? "wait" : "pointer")}
  ${(props) =>
    props.type == "primary"
      ? `   
      ${SortItem} + ${SortItem} {
        margin-left: 0;
      }
      
      ${SortLabel}{
        padding-right: 12px;
        &.rotated {
          &::after {
            display: none;
          }
        }
      }
     
      
    `
      : `
        ${SortList}{         
            display: none;          
        }
      `}
  };
`;
